import { Directive, ElementRef, Input, Renderer, SimpleChanges } from '@angular/core';

@Directive({ selector: 'img[imgPreview]' })
export class ImagePreview 
{
	@Input() image: any;

	constructor(private el: ElementRef, private renderer: Renderer) { }

	ngOnChanges(changes: SimpleChanges) {
		let reader = new FileReader();
		let el = this.el;
		reader.onloadend = function (e) {
			el.nativeElement.src = reader.result;
		};
		if (this.image) { return reader.readAsDataURL(this.image); }
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/directives/image-preview.directive.ts